/* eslint-disable */
import React, { useRef, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../../utils/functions/api';
import Loading from '../Loading';

const WalletPopup = ({
  open,
  onClose,
  WalletImage,
  bank,
  tokens,
  etaxData,
  payType,
  language,
}) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const urlOPS = useRef('');
  const formOPS = useRef('');

  const handlePaymentClick = async () => {
    setIsLoading(true);
    try {
      const WalletBank = bank[0].bankName;
      const { data } = await api.post(
        `${process.env.REACT_APP_APIHOST}/createpayment`,
        {
          source: `DW ${bank} ${etaxData?.branchCode ?? ''} ${
            etaxData?.tax ?? ''
          } ${etaxData?.postalCode ?? ''}`,
          eTaxData: {
            BUYER_NAME: etaxData?.name,
            BUYER_TAX_ID_TYPE: etaxData?.taxpayerType,
            BUYER_TAX_ID: etaxData?.taxId,
            BUYER_BRANCH_ID: etaxData?.branchCode,
            BUYER_POST_CODE: etaxData?.postalCode,
            BUYER_ADDRESS_LINE1: etaxData?.address,
            BUYER_ADDRESS_LINE2: etaxData?.address2,
          },
          etaxname: etaxData?.etaxname ?? '',
          etaxaddress1: etaxData?.etaxaddress1 ?? '',
          etaxaddress2: etaxData?.etaxaddress2 ?? '',
          email: etaxData?.email ?? '',
          term: payType === 'IN' ? etaxData?.term : null,
          card_id: etaxData?.select_card?.card_id ?? '',
        },
        { headers: { Authorization: tokens } },
      );
      setIsLoading(false);
      if (data.status === 'paid' && data.company_callback) {
        navigate(
          `/transactionResult?authorization=${tokens}&urlPDF=${encodeURIComponent(
            data.eTaxPDF,
          )}`,
        );
      } else if (data.status === 'paid' && !data.company_callback) {
        navigate(
          `/transactionResult?status=success&urlPDF=${encodeURIComponent(
            data.eTaxPDF,
          )}`,
        );
      } else if (data.status === 'pending' && data.company_callback) {
        navigate(
          `/transactionResult?status=pending&urlPDF=${encodeURIComponent(
            data.eTaxPDF,
          )}`,
        );
      } else if (data.status === 'pending' && !data.company_callback) {
        navigate(
          `/transactionResult?status=pending&urlPDF=${encodeURIComponent(
            data.eTaxPDF,
          )}`,
        );
      } else if (data.status === 'cancel' && !data.company_callback) {
        navigate(
          `/transactionResult?status=cancel&urlPDF=${encodeURIComponent(
            data.eTaxPDF,
          )}`,
        );
      } else {
        window.location.replace(data.paymentURL);
        urlOPS.current = data.paymentToken;
        formOPS.current = data.paymentURL;
        setTimeout(() => {
          const form = document.createElement('form');
          form.method = 'POST';
          form.action = urlOPS.current;
          form.innerHTML = formOPS.current;
          document.body.appendChild(form);
          form.submit();
        }, 750);
      }
    } catch (error) {
      console.error('Error processing payment:', error);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '15px',
        },
      }}
    >
      <Loading isLoading={isLoading} />
      <DialogTitle>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            fontWeight: 'bold',
            fontSize: '20px',
            marginTop: '20px',
            marginLeft: '20px',
          }}
        >
          {language === 'TH'
            ? 'ช่องทางการชำระผ่าน Wallet'
            : 'Payment via Wallet'}
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            marginTop: '40px',
            marginBottom: '30px',
          }}
        >
          <img src={WalletImage} alt="WalletImage" style={{ width: '90%' }} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            gap: 2,
            marginBottom: '40px',
          }}
        >
          <Button
            onClick={onClose}
            sx={{
              width: '100px', // Adjust the width as needed
              border: '1px solid',
              color: '#FC3A3A',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(252, 58, 58, 0.1)',
              },
            }}
          >
            {language === 'TH' ? 'ยกเลิก' : 'Cancel'}
          </Button>
          <Button
            onClick={handlePaymentClick}
            sx={{
              width: '100px', // Adjust the width as needed
              border: '1px solid ',
              color: '#51D245',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(81, 210, 69, 0.1)',
              },
            }}
          >
            {language === 'TH' ? 'ยืนยัน' : 'Confirm'}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default WalletPopup;
